import { Flex, VStack, Heading, useToast, Spinner, InputGroup, Input, InputLeftElement, FormControl, FormLabel, RadioGroup, Button, Box, Text, Stack, Radio, Select } from "@chakra-ui/react";
import { BlockchainNetwork, OlaggModule, PermissionEnum, TokenData } from "@olagg/db-types";
import { useCallback, useEffect, useState, useRef } from "react";
import useRoles from "../../../features/Roles/hooks/useRoles";
import { useForm, Controller, FormProvider } from 'react-hook-form'
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {
    fetcher,
    AdminStreaksEndpoints,
} from '@olagg/api-hooks'
import { BsSearch } from "react-icons/bs";
import { FaChevronRight, FaTrash } from "react-icons/fa";
import OlaggFormInput from "../../../components/Forms/OlaggFormInput";
import OlaggFormSelect from "../../../components/Forms/OlaggFormSelect";
import useBlockchainTokenCatalog from "../../BlockchainTokenCatalog/hooks/useBlockchainTokenCatalog";
import useBlockchainNetwork from "../../BlockchainTokenCatalog/hooks/useBlockchainNetwork";

type FormData = {
    name: string,
    active: boolean,
    streaksAttributes: StreaksAttributes
}

type StreaksAttributes = {
    iteration: number,
    awardId?: number,
    awardType?: string,
    awardQuantity?: number,
    score?: number,
}

const schema: Yup.Schema<FormData> = Yup
    .object({
        name: Yup.string().required('Nombre de la campaña obligatorio'),
        active: Yup.boolean()
    })
    .required()

const StreakForm = () => {
    const { missingPermission } = useRoles();
    const toast = useToast()

    const [isLoading, setIsLoading] = useState(false)

    const useFormMethods = useForm<FormData>({
        resolver: yupResolver(schema),
        mode: 'onChange',
    });

    const errors = useFormMethods.formState.errors;

    const onSubmit = (dataForm) => {
        let payload = dataForm
        if (streaksAttributes.length > 0) payload.streaksAttributes = streaksAttributes

        setIsLoading(true)
        fetcher(AdminStreaksEndpoints.new(payload))
            .then(() => {
                toast({
                    title: 'Campaña creada',
                    colorScheme: 'olaggPink',
                    status: 'success',
                    description: '',
                    position: 'bottom-right'
                })
                useFormMethods.reset()
                setTypeAward('XP')
                useFormMethods.setValue('streaksAttributes.awardId', undefined)
                useFormMethods.setValue('streaksAttributes.awardQuantity', undefined)
                useFormMethods.setValue('streaksAttributes.score', undefined)
                setSelectedNetwork(null)
                setIsLoading(false)
            })
            .catch(e => {
                toast({
                    title: 'Error',
                    colorScheme: 'olaggYellow',
                    status: 'error',
                    description: e?.error?.message,
                    position: 'bottom-right'
                })
                setIsLoading(false)
            })
    }

    const [typeAward, setTypeAward] = useState('XP')

    const { all, blockchainTokens } = useBlockchainTokenCatalog();
    const { all: allNetworks, blockchainNetworks } = useBlockchainNetwork();

    const [selectedNetwork, setSelectedNetwork] = useState<string | null>(null);
    const [selectedToken, setSelectedToken] = useState<string | null>(null);

    const filteredBlockchainTokens = selectedNetwork
        ? blockchainTokens?.filter(token => token.network.name === selectedNetwork)
        : blockchainTokens;

    useEffect(() => {
        all({ page: 1, limit: 100 });
        allNetworks({ page: 1, limit: 100 });
    }, [])

    const handleNetworkChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedNetwork(event.target.value);
    };

    const [streaksAttributes, setStreaksAttributes] = useState([])

    const getAwardSymbol = (id) => {
        let symbol = ''
        let current = blockchainTokens.filter(bt => bt.id == id)
        if (current.length > 0) symbol = current[0]?.name
        return symbol
    }

    const removeWeek = (attr) => {
        const newAttributes = streaksAttributes.filter(sa => sa != attr)
        setStreaksAttributes(newAttributes);
    }

    const refToken = useRef()
    const refQuantity = useRef()
    const refScore = useRef()
    const refWeek = useRef()

    const addWeek = () => {
        let awardType = typeAward
        let score = undefined
        let iteration = refWeek.current.value
        let awardId = undefined
        let awardQuantity = undefined

        if (typeAward == 'XP') {
            score = refScore.current.value
        }

        if (typeAward == 'BlockchainToken') {
            awardId = refToken.current.value
            awardQuantity = refQuantity.current.value
        }

        let week = {
            awardType: awardType == 'XP' ? '' : awardType,
            awardId: awardId,
            awardQuantity: awardQuantity,
            score: score,
            iteration: iteration,
        }

        let currentAttributes = JSON.stringify(streaksAttributes)
        let newAttributes = JSON.parse(currentAttributes)
        newAttributes.push(week)
        setStreaksAttributes(newAttributes)

        setTypeAward('XP')
        refWeek.current.value = ''
        refScore.current.value = ''
        setSelectedNetwork(null)
        setSelectedToken(null)
        refQuantity.current.value = ''
    }

    return (
        <Flex w={'full'} py={'15px'} pb={4} minH='600px' justifyContent='center'>
            <VStack color={'white'} w={'full'} maxW={'640px'}>
                <Flex flexDirection="column" w={'full'}>
                    <Heading fontSize={'30px'}>Cargar nueva campaña</Heading>
                </Flex>

                <Flex w={'full'} flexDirection='column'>

                    <Flex position={'relative'} zIndex='0' mt={'20px'}>
                        <FormProvider {...useFormMethods}>
                            <form onSubmit={useFormMethods.handleSubmit(onSubmit)} style={{ width: '100%' }}>

                                <OlaggFormInput
                                    label='Nombre'
                                    controlName={'name'}
                                    placeholder='Nombre'
                                />

                                <OlaggFormInput
                                    label='Activar ?'
                                    controlName='active'
                                    inputType='switch'
                                    required={false}
                                    chakraStyles={{ colorScheme: 'red' }}
                                />

                                <Flex bgColor='#20173d' borderRadius='12px' p='12px' flexDirection={'column'} mb='32px'>

                                    <Text fontSize={'18px'} fontWeight='bold' mb='12px'>Agregar racha</Text>
                                    <Flex flexDirection={'column'} gap='12px'>
                                        <Text fontSize={'14px'} fontWeight='700'>Tipo de premio</Text>

                                        <Select value={typeAward} placeholder="Seleccionar tipo" onChange={(event) => setTypeAward(event.target.value)}>
                                            <option value={'XP'}>XP</option>
                                            <option value={'BlockchainToken'}>Token</option>
                                        </Select>

                                        {typeAward != null && typeAward == 'BlockchainToken' && (
                                            <>
                                                <Text fontSize={'14px'} fontWeight='700'>Blockchain Token Network Filter</Text>
                                                <Select value={selectedNetwork} style={{ marginBottom: '10px' }} placeholder="Select network" onChange={handleNetworkChange}>
                                                    {
                                                        blockchainNetworks?.map(network => (
                                                            <option key={network.id} value={network.name}>{network.name}</option>
                                                        ))
                                                    }
                                                </Select>
                                                {selectedNetwork && (
                                                    <>
                                                        <Text fontSize={'14px'} fontWeight='700'>Blockchain Token</Text>
                                                        <Select onChange={(event) => setSelectedToken(event.target.value)} value={selectedToken} ref={refToken}>
                                                            {filteredBlockchainTokens?.map(t => (
                                                                <option key={t.id} value={t.id}>{t.name}</option>
                                                            ))}
                                                        </Select>

                                                        <Text fontSize={'14px'} fontWeight='700'>Cantidad</Text>
                                                        <Input ref={refQuantity} type='number' />
                                                    </>
                                                )}
                                            </>
                                        )}

                                        {typeAward != null && typeAward == 'XP' && (
                                            <>
                                                <Text fontSize={'14px'} fontWeight='700'>Score</Text>
                                                <Input ref={refScore}
                                                    placeholder='Puntos XP'
                                                />
                                            </>
                                        )}

                                        <Text fontSize={'14px'} fontWeight='700'>Semana</Text>
                                        <Input ref={refWeek}
                                            placeholder='Numero de semana'
                                        />

                                        <Button variant={'solid'} colorScheme='green' onClick={addWeek}>Agregar</Button>
                                    </Flex>

                                </Flex>

                                <Flex bgColor='#20173d' borderRadius='12px' p='12px' flexDirection={'column'} mb='32px'>
                                    <Text fontSize={'18px'} fontWeight='bold'>Rachas</Text>
                                    {streaksAttributes.map((sa, index) => (
                                        <Flex flexDirection={'column'} key={index} my='20px'>
                                            <Flex fontWeight='bold' gap='15px'>
                                                Semana {sa?.iteration}
                                                <Button onClick={() => removeWeek(sa)} variant='outline' p='8px' h={'22px'} fontSize='14px'>Eliminar</Button>
                                            </Flex>
                                            <Flex>
                                                <Text fontWeight={'bold'} mr='6px'>Premio:</Text> {sa?.awardType == 'BlockchainToken' ? `${sa?.awardQuantity || 0} ${getAwardSymbol(sa?.awardId)}` : `${sa?.score} XP`}
                                            </Flex>
                                        </Flex>
                                    ))}
                                    {streaksAttributes.length == 0 && (
                                        <>
                                            No hay semanas seteadas
                                        </>
                                    )}
                                </Flex>

                                <Button
                                    variant={'filledGradient'}
                                    isLoading={isLoading}
                                    type="submit"
                                    w={'full'}
                                    style={{
                                        marginTop: '30px'
                                    }}
                                    isDisabled={isLoading || missingPermission(OlaggModule.Streak, PermissionEnum.CREATE)}
                                >
                                    Cargar campaña
                                </Button>
                            </form>
                        </FormProvider>
                    </Flex>
                </Flex>
            </VStack >
        </Flex >
    )
};

export default StreakForm;
